if (!customElements.get('blog-tag-nav')) {
  customElements.define(
    'blog-tag-nav',
    class BlogTagNav extends HTMLElement {
      constructor() {
        super();
        this.pills = this.querySelectorAll('.subcategory-nav__pill');
        this.container = document.getElementById('MainBlogArticles');
        this.bindEvents();
      }

      bindEvents() {
        this.pills.forEach((pill) => {
          pill.addEventListener('click', this.onPillClick.bind(this));
        });

        window.addEventListener('popstate', this.onPopState.bind(this));
      }

      onPillClick(event) {
        event.preventDefault();
        const href = event.currentTarget.getAttribute('href');
        if (!href) return;
        this.renderPage(href, true);
      }

      onPopState() {
        this.renderPage(window.location.href, false);
      }

      renderPage(url, updateHistory) {
        if (!this.container) return;

        const targetUrl = new URL(url, window.location.origin);
        const sectionId = this.container.dataset.id;
        const fetchUrl = `${targetUrl.pathname}?section_id=${sectionId}`;

        this.container.classList.add('loading');

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const newContainer = new DOMParser().parseFromString(responseText, 'text/html').getElementById('MainBlogArticles');

            if (newContainer) {
              this.container.innerHTML = newContainer.innerHTML;
            }

            if (updateHistory) {
              history.pushState({}, '', `${targetUrl.pathname}${targetUrl.search}`);
            }

            this.syncActiveState(targetUrl.pathname);
            this.container.classList.remove('loading');
          });
      }

      syncActiveState(pathname) {
        const match = pathname.match(/\/tagged\/([^/]+)/);
        const activeTagHandle = match ? decodeURIComponent(match[1]) : null;

        this.pills.forEach((pill) => {
          const isAll = pill.hasAttribute('data-subcategory-all');
          const isActive = (activeTagHandle === null && isAll) || pill.dataset.subcategoryHandle === activeTagHandle;

          pill.querySelector('.kt-button')?.classList.toggle('kt-button--active', isActive);
          if (isActive) {
            pill.setAttribute('aria-current', 'true');
          } else {
            pill.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
